<template>
    <v-app v-if="isSubpageView">
        <RouterView></RouterView>
    </v-app>
    <v-app v-else>
        <v-app-bar
            app
            dark
        >
            <RouterLink to="/">
                <div class="d-flex align-center">

                    <v-img
                        alt="Logo"
                        class="shrink mr-2"
                        contain
                        src="/static/logo.png"
                        transition="scale-transition"
                        width="40"
                    />

                    <h1>Kuźnia FLEX</h1>
                </div>
            </RouterLink>

            <v-spacer></v-spacer>
            <v-btn
                text
                large
            >
                <RouterLink to="cutoff">
                    <span class="mr-2 text-h5">Cutoff</span>
                    <v-icon>mdi-open-in-new</v-icon>
                </RouterLink>
            </v-btn>
            <v-btn
                text
                large
            >
                <RouterLink to="leaderboard">
                    <span class="mr-2 text-h5">Leaderboard</span>
                    <v-icon>mdi-open-in-new</v-icon>
                </RouterLink>
            </v-btn>
        </v-app-bar>

        <v-main>
            <RouterView></RouterView>
        </v-main>
    </v-app>
</template>
<script>

export default {
    name: 'App',

    components: {},

    data: () => ({
        //
    }),
    computed: {
        isSubpageView() {
            return this.$route.path.includes("/emisia");
        }
    }
};
</script>

<style>
.v-application .v-app-bar a {
    text-decoration: none;
    color: inherit;
}
</style>